<style lang="scss" scoped>
.mainbar {
}
.container {
  padding: 40px;
}
.top-bar {
  background: hsl(0, 0, 85);
}
.left-bar {
  background: hsl(0, 0, 90);
}
.right-bar {
  background: hsl(0, 0, 90);
}
.c-title {
  padding-bottom: 30px;
}
</style>


<template>
  <div class="layout flex-v">
    <!-- topbar -->
    <div class="top-bar">
      <c-topbar/>
    </div>

    <div class="flex-h">

      <!-- leftbar -->
      <div class="left-bar flex-v flex-limit">
        <c-sidebar/>
      </div>

      <!-- main section -->
      <div class="mainbar flex-h scroll">
        <div class="container flex-v">

          <!-- title -->
          <div class="c-title flex-h flex-align-center flex-limit">
            <div class="is-size-2">
              <slot name="title"></slot>
            </div>
            <div class="flex-spacer"></div>
            <slot name="toolbar"></slot>
          </div>

          <!-- content -->
          <div class="main flex-v">
            <slot name="content"></slot>
          </div>

        </div>
      </div>

      <!-- right bar -->
      <div class="right-bar flex-v flex-limit">
        <slot name="drawer"></slot>
      </div>
    </div>
  </div>
</template>


<script>
import Topbar from './topbar';
import Sidebar from './sidebar';

export default {
  name: 'layout',
  components: {
    'c-topbar': Topbar,
    'c-sidebar': Sidebar,
  },
};
</script>
